import React, { useEffect, useState } from 'react';
import classes from './ColorPicker.module.css';

export default function ColorChannelInput({ channel, value, onChange }: { channel: string; value: number; onChange: (value: number) => void }) {
    const [draft, setDraft] = useState(String(value));
    const [focused, setFocused] = useState(false);
    const max = channel === 'A' ? 1 : 255;
    const normalize = (number: number) => channel === 'A' ? Math.round(number * 1000000) / 1000000 : Math.round(number);
    const parse = (text: string) => text.trim() === '' ? NaN : Number(text.replace(',', '.'));
    useEffect(() => { if (!focused) setDraft(String(value)); }, [value, focused]);
    return <input className={classes.colorPickerInput} type="text" inputMode={channel === 'A' ? 'decimal' : 'numeric'}
        aria-label={channel} placeholder={channel} maxLength={12} value={draft}
        onFocus={() => setFocused(true)} onChange={e => {
            const text = e.target.value;
            setDraft(text);
            const number = parse(text);
            if (Number.isFinite(number) && number >= 0 && number <= max && (channel === 'A' || Number.isInteger(number))) onChange(normalize(number));
        }} onBlur={() => {
            const number = parse(draft);
            const next = Number.isFinite(number) ? Math.max(0, Math.min(max, normalize(number))) : value;
            onChange(next);
            setDraft(String(next));
            setFocused(false);
        }} />;
}
